import React from 'react';

interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showText?: boolean;
  showTagline?: boolean;
  tagline?: string;
}

export const Logo: React.FC<LogoProps> = ({
  className = '',
  size = 'md',
}) => {
  const sizeMap = {
    sm: { img: 'h-6 w-auto', text: 'text-base', sub: 'text-[9px]' },
    md: { img: 'h-8 w-auto', text: 'text-lg', sub: 'text-[10px]' },
    lg: { img: 'h-10 w-auto', text: 'text-2xl', sub: 'text-xs' },
    xl: { img: 'h-14 w-auto', text: 'text-3xl', sub: 'text-sm' },
  };

  const currentSize = sizeMap[size];

  return (
    <div className={`inline-flex items-center gap-2.5 select-none ${className}`}>
      <img
        src="/logo.png"
        alt="Sahaj Connect Logo"
        className={`${currentSize.img} object-contain rounded-xl shadow-xs transition-transform hover:scale-105`}
      />
    </div>
  );
};
